module.exports = __webpack_public_path__ + "static/media/delivery-temporary-closed.61c43966.png";